import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { barcodeImageSrcGenerator } from '../templates/utils';
var useStyles = makeStyles(function (theme) { return ({
    barcodeImage: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: '303px',
        height: '121px',
    },
}); });
export var BarcodeImage = function (props) {
    var classes = useStyles();
    if (!props.barcodeValue) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Box, { textAlign: 'center' },
        React.createElement("img", { className: classes.barcodeImage, alt: props.barcodeValue, 
            // どうやらバーコードの縦線が最大で240ピクセルまで、あとは文字サイズが大きくなるだけのようなので
            // このサイズでの固定が無難だと思う
            src: barcodeImageSrcGenerator({
                barcode: props,
            }) })));
};
//# sourceMappingURL=BarcodeImage.js.map